export default "__VITE_ASSET__DRhNgaJC__"